import { render, staticRenderFns } from "./BpInput.vue?vue&type=template&id=58a7d65e&scoped=true&"
import script from "./BpInput.vue?vue&type=script&lang=js&"
export * from "./BpInput.vue?vue&type=script&lang=js&"
import style0 from "./BpInput.vue?vue&type=style&index=0&id=58a7d65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7d65e",
  null
  
)

export default component.exports